import { Injectable } from '@angular/core';
import {
    AbstractControl,
    AsyncValidator, AsyncValidatorFn,
    ValidationErrors,
} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {CarrierService} from '../services/carrier.service';
import {catchError, map, take} from 'rxjs/operators';


export class TaxNumberValidator {
    static createValidator(carrierService: CarrierService, id: number): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors> => {
            return carrierService
                .isTaxNumberExists(control.value,id)
                .pipe(
                    map((result: boolean) =>
                        result ? { taxnumberexists: true } : null
                    )
                );
        };
    }
}

// @Injectable({
//     providedIn: 'root',
// })
//
// export class TaxNumberValidator implements AsyncValidator {
//     constructor(private carrierService: CarrierService) {}
//
//     validate = (control: AbstractControl): Observable<ValidationErrors | null> => {
//
//         return this.carrierService.isTaxNumberExists(control.value).pipe(
//             map((response: boolean) => {
//                 if (response) {
//                     return { taxnumberexists: true };
//                 } else {
//                     return null;
//                 }
//             }),
//             catchError(() => of({ taxnumberexists: true }))
//         );
//     };
//
// }
